<template>

  <el-container>
    <el-main class="pc">
      <el-header class="index-header">
        <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff"
          active-text-color="#fff">
          <div class="w1200" style="height:60px">
            <div class="logobox fl">
              <img src="../assets/img/logo.png">
            </div>
            <div class="titleNames fl over_h">
              <div class="titleT fl">活畜在线交易平台</div>
            </div>

            <el-submenu index="2" class="submenu">
              <template slot="title" v-if="user!=null">
                <span class="text">{{user.userName||''}}</span>
              </template>
              <template slot="title" v-else>
                <div @click="exits()">登录&nbsp;|&nbsp;注册</div>
              </template>
              <!--   <el-menu-item index="2-1">设置</el-menu-item>
                <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
              <el-menu-item v-if="user!=null" @click="editInfo()" index="2-3">账号管理</el-menu-item>
              <!--  <el-menu-item v-if="user!=null" @click="editPwd()" index="2-3">修改密码</el-menu-item>
                <el-menu-item v-if="user!=null" @click="exit()" index="2-3">注销登录</el-menu-item> -->
              <el-menu-item v-if="user!=null" @click="exit()" index="2-3">退出</el-menu-item>
            </el-submenu>
          </div>
        </el-menu>
      </el-header>
      <div class="w1200">
        <div class="goBack" @click="goback"> 返回 ></div>
      </div>
      <div class="w1200 infoCont">
        <div class="tabs">账号管理</div>
        <div class="infoList">
          <ul>
            <li>
              <label>昵称</label>
              <p>{{user.userName||''}}</p>
              <span @click="editName">修改昵称</span>
            </li>
            <li>
              <label>联系电话</label>
              <p>{{userPhone||''}}</p>
            </li>
            <li>
              <label>密码</label>
              <p style="font-weight:bold;font-size:28px;">········</p>
              <span @click="editPwd">修改密码</span>
            </li>
            <li>
              <label>注销账号</label>
              <p>如果未来不再使用该账号，可以进行注销,注销成功后，账号中的所有服务数据以及隐私信息均会删除,并无法恢复</p>
              <span @click="link">联系客服</span>
            </li>
          </ul>
        </div>
      </div>
      <footer class="footer">
        <p>备案号：<a href="http://beian.miit.gov.cn/" target="_blank">陕ICP备2020017629号</a>   <a href="http://xiaomuding.com/measures.html" target="_blank">网站监管措施</a></p>
        <p>陕西微牧云信息科技有限公司</p>
        <p>电话：159 2939 7888&emsp;地址：陕西省榆林市高新区明珠大道榆商大厦B座26层</p>
        <p>本站信息皆来自第三方用户发布，请谨慎甄别信息真实性与合法性，如有侵犯您利益，请第一时间与我们联系</p>
      </footer>
      <div>
        <div class="dialogs" v-show="dialogs==true" @click="closeDialog"></div>
        <div class="maskss" v-show="editNames==true">
          <h3>修改昵称</h3>
          <div class="close" @click="closeDialog"></div>
          <div class="maskBoxss">
            <div class="editInput">
              <input type="text" v-model="user.userName" placeholder="请输入昵称" />
            </div>
          </div>
          <div class="layuiBtns">
            <a class="cancel" @click="closeDialog">取消</a>
            <a class="confirm" @click="confrim">确定</a>
          </div>
        </div>
        <div class="maskss" v-show="editPwds==true" style="width: 400px;height: 600px;">
          <h3>修改密码</h3>
          <div class="close" @click="closeDialog"></div>
          <div class="maskBoxss">
            <ul style="float: none;margin:auto">
              <li>
                <label>联系电话<i>*</i></label>
                <input type="text" v-model="sendCode.userAccount" placeholder="请输入联系电话" />
              </li>
              <li>
                <label>验证码<i>*</i></label>
                <input style="width:55%" v-model="editPwdInfo.phoneCode" type="text" placeholder="请输入验证码" />
                <button @click="getCode" v-if="setCode=='获取验证码'" class="code getCode">{{setCode}}</button>
                <button v-else class="getCode colorG">{{setCode}}</button>
              </li>
              <li>
                <label>请输入修改的密码<i>*</i></label>
                <input type="password" v-model="editPwdInfo.userPwd" name="pas" auto-complete="new-password"
                  autocomplete="off" @blur="execl" placeholder="请输入密码" />
                <div class="passF">
                  密码至少包括大写字母、小写字母、数字、特殊符号中任意三种
                </div>
              </li>

              <li>
                <label>请确认修改的密码<i>*</i></label>
                <input type="password" v-model="userPwdInput" name="changePas" auto-complete="new-password"
                  autocomplete="off" @blur="execls" placeholder="请输入确认密码" />
              </li>
            </ul>
            <div style="clear: both;"></div>
          </div>
          <div class="layuiBtns" style="margin-top: 70px;">
            <a class="cancel" @click="closeDialog">取消</a>
            <a class="confirm" @click="confrimEditorPwd">确定</a>
          </div>
        </div>
      </div>
    </el-main>
    </div>

  </el-container>
</template>
<script>
  // 导入组件
  import {
    listApi,
    listApiF,
    detailApi,
    uploadFile,
    addCameraDevice,
    editNameApi,
    sendCodeApi,
    editPwdApi

  } from '@/api/index'
  export default {
    name: 'index',
    data() {
      return {
        userPwdInput: '',
        userPhone: '',
        editNames: false,
        editPublick: false,
        editInfos: false,
        editDialogs: false,
        editPwds: false,
        user: null,
        area: {},
        inputVal: '',
        publishForm: true,
        imageUrl: '',
        tabIndexP: -1,
        dialogs: false,
        phoneshow: false,

        showclass: 'asideshow',
        showtype: false,
        tabIndex: 0,

        detailFlag: false,
        info: {
          deviceNo: ''
        },
        detail: null,
        pageStatus: true,
        showSearch: false,
        loadding: false,
        showPhone: false,
        editNameInfo: {
          nickname: '',

        },
        setCode: '获取验证码',
        editPwdInfo: {
          phoneCode: '',
          userAccount: '',
          userPwd: ''
        },
        sendCode: {
          clientFlag: 'pc',
          codeType: '2',
          userAccount: ''
        },
        ruleForm: {
          userPwd: '',
          userAccount: '',
          clientFlag: 'pc',
          phoneCode: ''

        },
        num: 60
      }
    },
    // 注册组件
    components: {
    },
    methods: {
      execl(e) {
        // console.log(e.)

      },
      execls(e) {
        console.log(e.detail.value)
        // this.userPwdInput = e.detail.value

      },
      getCode() {
        // this.sendCode.userAccount = this.ruleForm.userAccount

        sendCodeApi(this.sendCode).then(res => {
          console.log(res)
          if (res.data.code == '0') {
            alert('短信验证码发送成功')
          } else {
            alert(res.data.msg)
          }
          if (res.data.data.code == '1') {
            return;
          }
          this.setCode = this.num + '秒后可重新获取';
          let _this = this
          let clock = setInterval(function() {
            _this.num--;
            if (_this.num > 0) {
              _this.setCode = _this.num + '秒后可重新获取';
            } else {
              clearInterval(clock); //清除js定时器

              _this.setCode = '获取验证码';
              _this.num = 60; //重置时间
            }
          }, 1000);


        }).catch(res => {
          this.setCode = '获取验证码';
          this.num = 60; //重置时间
        })
      },
      goback() {
        this.$router.push({
          path: '/index'
        })
      },

      handleClick(tab, event) {
        console.log(tab, event);
      },

      editName() {
        this.dialogs = true
        this.editNames = true
      },
      confrim() {
        this.editNameInfo.nickname = this.user.userName
        editNameApi(this.editNameInfo).then(res => {
          localStorage.setItem('userInfo', JSON.stringify(this.user))
          this.dialogs = false
          this.editNames = false

        })
      },
      //修改密码
      editPwd() {
        this.dialogs = true
        this.editPwds = true
      },
      confrimEditorPwd() {
        this.editPwdInfo.userAccount = this.sendCode.userAccount
        if (this.editPwdInfo.userAccount == '') {
          alert('请输入手机号')
        } else if (this.editPwdInfo.phoneCode == '') {
          alert('请输入短信验证码')
        } else if (this.editPwdInfo.userPwd == '') {
          alert('请输入修改后密码')
        } else {
          console.log(this.editPwdInfo.userPwd)
          let reg =
            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{1,32}$/;
          console.log(reg.test(this.editPwdInfo.userPwd))
          if (reg.test(this.editPwdInfo.userPwd) == true) {
            if (this.editPwdInfo.userPwd == this.userPwdInput) {
              editPwdApi(this.editPwdInfo).then(res => {
                alert('修改成功')
                this.dialogs = false
                this.editPwds = false
              })
            } else {
              if (this.userPwdInput.length > 0) {
                alert('两次密码输入不一致，请重新输入密码')
              }
            }
          } else {
            if (this.editPwdInfo.userPwd.length > 0) {
              alert('请设置正确的密码')
            }
          }
        }
      },
      closeDialog() {
        this.dialogs = false
        this.editNames = false
        this.editPublick = false
        this.editPwds = false
      },
      link() {
        alert('如需注销账号，请联系客服15929397888')
      },






      // 退出登录
      exits() {
        this.$store.commit('logout', 'false')
        this.$router.push({
          path: '/login'
        })
        localStorage.removeItem('userInfo')
        this.user = null
      },
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            setTimeout(() => {
              this.$store.commit('logout', 'false')
              this.$router.push({
                path: '/login'
              })
              this.$message({
                type: 'success',
                message: '已退出登录!'
              })
              localStorage.removeItem('userInfo')
              this.user = null
            }, 1000)

          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },


    },
    async created() {
      this.user = JSON.parse(localStorage.getItem('userInfo'))
      this.userPhone = localStorage.getItem('userPhone')
      console.log(this.user)

    },
    beforeUpdate() {},
    // 挂载前状态(里面是操作)
    beforeMount() {
      // 弹出登录成功
      // this.$message({
      //   message: '登录成功',
      //   type: 'success'
      // })
    }
  }
</script>
<style scoped="scoped">
  @import url("index.css");
  @import url("../assets/css/reset.css");
  @import url("../assets/css/animate.css");
  @import url("../assets/css/style.css");

  .footer {
    text-align: center;
    border-top: 1px solid #e8e8e8;
    padding: 20px 0;
  }

  .footer p {
    font-size: 16px;
    line-height: 40px;
  }

  a {
    color: #000;
  }

  .el-main {
    background: #f7f7f7;
    padding: 0 !important;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .clear,
  .layui-clear {
    clear: both;
  }

  .over_h {
    overflow: hidden;
  }

  .dis_n {
    display: none;
  }

  .index-nav {
    height: 20px;
    width: 100%;
    background: #F6F7FB;
  }

  .index-con {
    height: calc(100vh - 90px);
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;
  }

  .aside {
    width: 60px !important;
    height: 100%;
    background-color: #fff;
    margin: 0px;
  }

  .asideshow {
    width: 280px !important;
    height: 100%;
    background-color: #f6f7fb;
    margin: 0px;
  }

  .asideshow .el-menu-vertical-demo.el-menu {
    background-color: #f6f7fb !important;
  }

  .el-menu-vertical-demo>li.el-menu-item:nth-child(2) {
    margin-top: 60px
  }

  .index-header {
    padding: 0;
    height: 90px !important;
    background: #fff;
    box-shadow: 0px 5px 10px rgb(0 0 0 / 3%);
  }

  .index-header .el-menu.el-menu--horizontal {
    background: #fff !important;
    border: none;
    /* box-shadow: 0px 5px 10px rgb(0 0 0 / 3%); */
  }

  .el-submenu {
    min-height: 40px;
    line-height: 40px;
    margin-top: 10px
  }

  .el-menu-vertical-demo.el-menu div:last-child {
    border-top: solid 1px #e4e5e7;
  }

  .el-menu-vertical-demo.el-menu div:nth-child(2) i.el-icon-menu::before {
    content: '';
    background: url(../assets/img/u79.png) no-repeat center;
    background-size: 20px auto;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .el-menu-vertical-demo.el-menu div:last-child i.el-icon-menu::before {
    content: '';
    background: url(../assets/img/u223.png) no-repeat center;
    background-size: 20px auto;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    outline: 0;
    background-color: #f6f7fb;
  }

  /deep/ .el-submenu__title {
    height: 40px;
    line-height: 40px;
    width: 150px !important;
    background: #f6f7fb !important;
    border: none;
    color: #333 !important;
    font-size: 16px
  }

  .is-active div span {
    color: #30BF30;
    font-weight: bold;
  }

  .el-menu-item {
    /* padding-left: 45px !important; */
    font-size: 15px;
    background: #f6f7fb !important;
    color: #333 !important;
  }

  .el-menu-item.is-active {
    color: #30BF30 !important;
    font-weight: bold;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__title {
    background: #fff !important;
    border: none;
    color: #333 !important;
  }

  .el-menu-demo.el-menu--horizontal.el-menu .submenu.el-submenu {
    border: none
  }

  .el-menu--horizontal {
    /* left: 1163px !important; */
  }

  .el-menu--horizontal .el-menu--popup {
    text-align: center;
  }

  .el-menu.el-menu--popup.el-menu--popup-bottom-start {
    background: #fff !important;
    min-width: 130px !important;
  }

  .el-menu--horizontal .el-menu-item {
    background: #fff !important;
    border: none;
    color: #333 !important
  }

  .index-main {
    padding: 0px;
    background: #fff;
  }

  .w1200 {
    width: 1280px;
    margin: 0 auto;
  }

  .w1200:focus {
    outline: 0;
  }

  .cover {
    padding-bottom: 30px;
  }

  .cover>img {
    margin: 50px auto 30px;
    max-width: 100%;
    display: block;
  }

  .fl.text- {
    font-size: 18px;
    color: #333;
    width: 98%;
  }

  .detailsBox {
    margin-top: 30px;
  }

  .detailsBoxL {
    width: calc(100% - 380px);
  }

  .detailsBoxL .imgUrl {
    width: 360px;
    height: 360px;
    background-size: cover;
    float: left;
  }

  .detailsBoxLL {
    float: left;
    margin-left: 60px;
  }

  .detailsBoxLL h3 {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #333333;
    text-align: left;
    line-height: 20px;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .item {
    width: 240px;
    height: 60px;
    background: url(../assets/img/u63.svg) no-repeat center top;
    background-size: cover;
    font-size: 20px;
    color: #FFFFFF;
    outline: none;
    border: none;
    padding: 0;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }

  .items {
    width: 240px;
    text-align: center;
    margin-top: 10px;
  }

  .item span {
    line-height: 60px;
  }

  .detailsBoxR {
    float: right;
    width: 340px;
  }

  .detailsBoxR h3 {
    font-family: 'Arial Negreta cursiva', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: italic;
    font-size: 20px;
    color: #333333;
    text-align: left;
    line-height: 20px;
  }

  .detailsBoxR h3 span {
    width: 40px;
    height: 20px;
    background-color: rgba(245, 247, 250, 1);
    border-radius: 2px;
    font-size: 12px;
    color: #999999;
    line-height: 20px;
    display: inline-block;
    float: right;
    font-style: normal;
    text-align: center;
    font-weight: normal;
  }

  .detailsBoxR ul {}

  .detailsBoxR ul li {
    float: left;
    width: 160px;
    margin: 20px 20px 0 0;
  }

  .detailsBoxR ul li:nth-child(2n) {
    margin: 20px 0px 0 0;
  }

  .detailsBoxR ul li div,
  .detailsBoxR ul li img {
    width: 160px;
    height: 160px;
    cursor: pointer;
    background-size: cover;
  }

  .detailsBoxR ul li p {
    margin-top: 10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .yzm-search {
    display: inline-block;
    margin: 10px 0 0 60px
  }

  .searchtxt {
    float: left;
    width: 366px;
    height: 36px;
    border: 2px solid #30bf30;
    border-right: 0;
    position: relative;
    z-index: 100;
    background: #fff;
    border-radius: 5px;
  }

  .searchtxt input {
    float: left;
    border: 0;
    background: #fff;
    color: #666;
    padding: 7px 8px;
    width: 96%;
    height: 22px;
    line-height: 22px;
    margin: 0;
    outline: medium none;
    text-indent: 5px;
  }

  .searchbtn {
    float: left;
  }

  .searchbtn div {
    background: #30bf30;
    color: #fff;
    outline: none;
    cursor: pointer;
    float: left;
    height: 40px;
    line-height: 40px;
    width: 80px;
    font-size: 16px;
    transition: all 0.3s;
    border-radius: 5px;
    margin-left: -7px;
    text-indent: 7px;
    text-align: center;
  }

  .yzm-add-content {
    width: 99px;
    float: right;
    margin-left: 30px;
  }

  .yzm-add-content a {
    text-decoration: none;
    border-radius: 2px;
    height: 38px;
    color: #30bf30;
    font-size: 14px;
    display: block;
    line-height: 40px;
    transition: 0.3s all;
    border: 1px solid #30bf30;
    text-align: center;
    border-radius: 5px;
  }

  .yzm-add-content a:hover {
    text-decoration: none;
    background: #30bf30;
    color: #fff;
  }

  .w1200 {
    width: 1280px;
    margin: 0 auto;
  }

  .el-menu-demo {
    position: fixed;
    top: 15px;
    left: 0;
    width: 100%;
    z-index: 999;
  }

  .titleT {
    color: #333333;
    font-size: 24px;
    /* margin-left: 15px; */
    font-weight: bold;
    display: inline-block;
    vertical-align: middle;
    height: 60px;
    line-height: 60px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  }

  .areaTitle {
    margin-left: 10px;
    margin-top: 15px;
    height: 30px;
    background-color: rgba(235, 235, 235, 1);
    border-radius: 15px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    padding: 0 10px;
  }

  .areaTitle img {
    width: 14px;
    height: 14px;
    opacity: .6;
    vertical-align: middle;

  }

  .titleImg {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }

  .submenu {
    float: right;
  }

  .buttonimg {
    height: 60px;
    background-color: transparent;
    border: none;
  }

  .showimg {
    width: 26px;
    height: 26px;
    position: absolute;
    top: 17px;
    left: 17px;
  }

  .showimg:active {
    border: none;
  }

  .logobox img {
    width: 120px;
    height: 30px;
    margin: 15px 20px 0 0;
  }

  .dialogs {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, .25);
    z-index: 9999999;
    outline: none;
  }

  .maskss {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 360px;
    height: 260px;
    z-index: 9999999;
    padding: 20px 40px;
    outline: none;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;
    -moz-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
    -webkit-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
  }

  .maskss h3 {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 20px;
  }

  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    background: url(../assets/img/images/close.png) no-repeat center;
    background-size: 20px 20px;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    width: 240px;
    height: 240px;
    ;
    font-size: 70px;
    color: #8c939d;
    line-height: 240px;
    text-align: center;
  }

  .avatar {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .maskBoxss {
    margin-top: 60px;
  }

  .uploadImg {
    width: 240px;
    float: left;
  }

  .uploadImg p,
  .maskBoxss ul li label {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    display: block;
  }

  .uploadImg p b,
  .maskBoxss ul li label i {
    font-weight: normal;
    color: #D92121;
    margin-left: 5px;
    font-style: normal;
  }

  .avatar-uploader {
    width: 240px;
    height: 240px;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 5px;
  }

  .avatar-uploader .imgMuchang {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .avatar-uploader .imgMuchang img {
    max-width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    bottom: 0;
  }

  .imgMuchang .del {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    z-index: 99999;
    cursor: pointer;
    background: rgba(0, 0, 0, .5);

  }

  .imgMuchang .del>img {
    margin: 7px;
    width: 26px;
    height: 26px;
  }

  .maskBoxss ul {
    float: right;
    width: 360px;
  }

  .maskBoxss ul li {
    margin-bottom: 30px;
    position: relative;
  }

  .maskBoxss ul li input {
    width: 360px;
    height: 40px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 5px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 16px;
    text-align: left;
    text-indent: 16px;
    line-height: 40px;
  }

  .typesss {}

  .typesss>div {
    width: 58px;
    height: 38px;
    background-color: rgba(245, 245, 245, 1);
    border: solid 1px rgba(245, 245, 245, 1);
    border-radius: 5px;
    font-size: 16px;
    color: #666666;
    line-height: 40px;
    display: inline-block;
    margin-right: 20px;
    text-align: center;
    cursor: pointer;
  }

  .typesss>div.cur {
    border-color: rgba(48, 191, 48, 1);
    color: #30BF30;
  }

  .layuiBtns {
    text-align: center;
    margin-top: 50px;
  }

  .layuiBtns a {
    text-align: center;
    width: 100px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    border-radius: 5px;
    margin: 0 10px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
  }

  .layuiBtns a.confirm {
    background: #30BF30;
    color: #fff;
  }

  .layuiBtns a.cancel {
    border: 1px solid #dedede;
    height: 38px;
    line-height: 38px;
    width: 98px;
    background: #fff;
  }

  .changeFilesBtn {
    background: url(../assets/img/upload2.png) no-repeat center;
    background-size: 130px auto;
    border: none;
    width: 240px;
    height: 240px;
    margin: 0 !important;
    padding: 0;
    border: none !important;
  }

  .changeFiles {
    cursor: pointer;
    position: absolute;
    width: 240px;
    height: 240px;
    left: 0;
    top: 0;
    opacity: 0;
  }

  /deep/ .el-button--primary:focus,
  .el-button--primary:hover {
    background: transparent !important;
  }

  /deep/ .el-button--primary.is-active,
  .el-button--primary:active {
    background: transparent !important;
  }

  .getCode {
    position: absolute;
    right: 5px;
    top: 30px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    border: none;
    outline: none;
    cursor: pointer;
    width: 140px;
    float: right;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
  }

  body {
    background: #f8f8f8 !important;
  }

  .infoCont {
    background: #fff;
    margin-top: 20px;
    margin-bottom: 50px !important;
    min-height: 584px;
  }

  .tabs {
    height: 50px;
    line-height: 50px;
    border-bottom: solid 1px #ebebeb;
    font-size: 18px;
    cursor: pointer;
    padding: 0 10px;
    font-weight: 900;
    color: #333;
    width: 90px;
    margin-left: 20px;
    margin-top: 10px;
    text-align: center;
    position: relative;
  }

  .tabs:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    background: #30BF30;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .infoList {}

  .infoList ul {
    margin-top: 50px;
  }

  .infoList ul li {
    line-height: 60px;
    font-size: 16px;
    position: relative;
  }

  .infoList ul li::after {
    content: '';
    position: absolute;
    width: calc(100% - 160px);
    height: 1px;
    background: #ebebeb;
    right: 0;
    left: 145px;
    bottom: 0;
  }

  .infoList ul li label {
    width: 100px;
    float: left;
    text-align: right;
    margin-right: 45px;
    display: inline-block;
    color: #666;
  }

  .infoList ul li span {
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 15px;
    color: #4c7399;
    cursor: pointer;
  }

  .infoList ul li p {
    color: #333;
    display: inline-block;
    width: calc(100% - 190px);
  }

  .goBack {
    font-size: 18px;
    color: #30BF30;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 20px;
  }

  .editInput input {
    width: 100%;
    border: solid 1px #d9d9d9;
    height: 40px;
    line-height: 40px;
    text-indent: 15px;
    font-size: 16px;
    border-radius: 3px;
  }

  .colorG {
    color: #999
  }

  .passF {
    font-size: 12px;
    color: red;
    margin-bottom: 5px;
  }

  .text {
    display: block;
    width: 100px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/info.vue